import DATE_FORMATS from '../../shared/constants/dateFormats';
import { formatDate } from '../../shared/utility/dateFormatter';

export const renderDate = (params) =>
  params.value ? formatDate(params.value, DATE_FORMATS.DD_MM_YYYY_HH_mm_A) : '';

export const renderDateValue = (value) =>
  value ? formatDate(value, DATE_FORMATS.DD_MM_YYYY_HH_mm_A) : '';
